import { W as WuiTabs$1, d as defineCustomElement$1 } from './p-JbeHhSQA.js';

const WuiTabs = WuiTabs$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTabs, defineCustomElement };
